export var ID = '@dimension-map';
export default {
    ID: ID
};
